import React, { useEffect } from "react";
import { useConnect, useAccount } from "wagmi";
import { createPortal } from "react-dom";
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import cn from "classnames";

import metaMaskIcon from "../../assets/images/icons/wallet/metaMask.svg";
// import coinbaseIcon from "../../assets/images/icons/wallet/coinbaseWallet.svg";
import walletConnectIcon from "../../assets/images/icons/wallet/walletConnect.svg";
import { useToastNotification } from "../../customHooks/useToastNotification";
import { _no } from "../../utils";
import styles from "./ConnectWalletModal.module.sass";
import Loader from "../Loader";
import Icon from "../Icon";

const SUCCESS_MESSAGE = "Successfully connected to wallet";

const walletIcons = {
    metaMask: metaMaskIcon,
    // coinbaseWallet: coinbaseIcon,
    walletConnect: walletConnectIcon,
};

const ConnectWallet = ({
    visible,
    onClose
}) => {
    const {
        connect,
        connectors,
        error,
        isLoading,
        pendingConnector,
    } = useConnect();

    const { isConnected } = useAccount();
    const toastNotification = useToastNotification();

    useEffect(() => {
        if (isConnected && visible) {
            toastNotification.success(
                SUCCESS_MESSAGE
            );
            onClose && onClose();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isConnected, onClose, visible]);

    useEffect(() => {
        if (visible) {
            const target = document.querySelector("#modal");
            disableBodyScroll(target);
        } else {
            clearAllBodyScrollLocks();
        }
    }, [visible]);

    useEffect(() => {
        if (error) {
            toastNotification.showTransactionErrorToast(
                error.message
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error]);

    const ConnectorButton = ({ connector }) => {
        const showLoading = isLoading && connector.id === pendingConnector?.id;

        return <button
            className={cn(
                "button-small",
                styles.button,
                {
                    disabled: _no(connector.ready) || isLoading,
                }
            )}
            disabled={_no(connector.ready)}
            onClick={() => connect({ connector })}
        >
            {showLoading
                ?
                <>
                    <Loader className={styles.loader} />
                    {`Connecting to ${connector.name} ...`}
                </>
                :
                <>
                    <img
                        src={walletIcons[connector.id]}
                        className={styles.walletIcon}
                        alt="wallet icon"
                    />
                    {connector.name}
                </>
            }
            {_no(connector.ready) && " (not detected)"}
        </button>;
    };

    return createPortal(
        visible && (
            <div id="modal" className={styles.modal}>
                <div className={cn(styles.outer)}>
                    <div>
                        <div className={cn("title-green", styles.title)}>
                            Connect Wallet
                        </div>
                        <div className={styles.wrapper}>
                            {connectors.map((connector) => (
                                <ConnectorButton connector={connector} key={connector.id} />
                            ))}
                        </div>
                    </div>
                    <button className={styles.close} onClick={onClose}>
                        <Icon name="close" size="20" />
                    </button>
                </div>
            </div >
        ),
        document.body
    );
};

export default ConnectWallet;
